import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createObjectifManagerEvaluationRequest, fetchObjectifsNMoins1StepRequest } from "../../../../redux/actions/performanceActions";
import { asArray, Field, StepState } from "../../Collaborateur/performanceUi";

export default function ObjectifsNMoins1ManagerStep({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.objectifsNMoins1);
    const data = slice.dataByProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const objectifs = asArray(data?.objectifs);
    const revisions = asArray(data?.revisions);
    const [drafts, setDrafts] = useState({});

    useEffect(() => {
        dispatch(fetchObjectifsNMoins1StepRequest(progressId));
    }, [dispatch, progressId]);

    const updateDraft = (id, patch) => setDrafts((current) => ({ ...current, [id]: { ...(current[id] || {}), ...patch } }));
    const save = (objectif) => {
        const draft = drafts[objectif.id] || {};
        const autoEvaluation = latestRevision(objectif.id, "AUTO_EVALUATION");
        const managerEvaluation = latestRevision(objectif.id, "MANAGER_EVALUATION");
        const tauxRealisation = draft.tauxRealisation ?? managerEvaluation?.tauxRealisation ?? autoEvaluation?.tauxRealisation;
        const commentaire = draft.commentaire ?? managerEvaluation?.commentaire ?? "";
        if (tauxRealisation === undefined || tauxRealisation === null || tauxRealisation === "") {
            window.alert("Veuillez saisir un taux manager.");
            return;
        }
        if (!String(commentaire || "").trim()) {
            window.alert("Veuillez saisir le commentaire manager.");
            return;
        }
        dispatch(createObjectifManagerEvaluationRequest(objectif.id, {
            evaluationProgressId: Number(progressId),
            tauxRealisation,
            commentaire,
        }));
    };
    const latestRevision = (objectifId, typeAction) => revisions.find((revision) => revision.objectifId === objectifId && revision.typeAction === typeAction);
    const isExpired = (dateFin) => {
        if (!dateFin) return false;
        const deadline = new Date(dateFin);
        deadline.setHours(23, 59, 59, 999);
        return new Date() > deadline;
    };

    return (
        <StepState loading={loading} error={error} empty={!data}>
            {data?.campagneNMoins1Nom && (
                <div className="perf-state perf-state--inline">
                    Objectifs N validés de : {data.campagneNMoins1Nom}
                </div>
            )}
            {data?.blockedReason && <div className="perf-state perf-state--warning">{data.blockedReason}</div>}
            {!data?.blockedReason && objectifs.length === 0 && <div className="perf-state">Aucun objectif N-1 disponible.</div>}
            <div className="perf-stack">
                {objectifs.map((objectif) => {
                    const autoEvaluation = latestRevision(objectif.id, "AUTO_EVALUATION");
                    const managerEvaluation = latestRevision(objectif.id, "MANAGER_EVALUATION");
                    const draft = drafts[objectif.id] || {};
                    const expired = isExpired(objectif.dateFin);
                    const displayStatus = managerEvaluation ? "VALIDE_MANAGER" : (objectif.statusObjectif || "OBJECTIF");
                    return (
                        <article className="perf-item" key={objectif.id}>
                            <div className="perf-item__head">
                                <h3>{objectif.titre}</h3>
                                <span className="perf-badge perf-badge--blue">{displayStatus}</span>
                            </div>
                            <p>{objectif.description || "Aucune description."}</p>
                            <dl className="perf-facts">
                                <div><dt>Cible</dt><dd>{objectif.performanceCible ?? "-"}</dd></div>
                                <div><dt>Auto-evaluation</dt><dd>{autoEvaluation?.tauxRealisation ?? "-"}%</dd></div>
                                <div><dt>Commentaire collaborateur</dt><dd>{autoEvaluation?.commentaire || "-"}</dd></div>
                                <div><dt>Validation manager</dt><dd>{managerEvaluation?.tauxRealisation ?? "-"}%</dd></div>
                                <div><dt>Poids</dt><dd>{objectif.poids ?? "-"}%</dd></div>
                            </dl>
                            {managerEvaluation && <div className="perf-state perf-state--inline">Valide par le manager - reevaluation possible</div>}
                            {!expired && <div className="perf-state perf-state--warning">Evaluation manager disponible apres la date d'echeance.</div>}
                            <div className="perf-form-row">
                                <Field label="Taux manager">
                                    <input
                                        type="number"
                                        min="0"
                                        max="200"
                                        disabled={!expired}
                                        value={draft.tauxRealisation ?? managerEvaluation?.tauxRealisation ?? autoEvaluation?.tauxRealisation ?? ""}
                                        onChange={(event) => updateDraft(objectif.id, { tauxRealisation: event.target.value })}
                                    />
                                </Field>
                                <Field label="Commentaire manager">
                                    <input
                                        disabled={!expired}
                                        value={draft.commentaire ?? managerEvaluation?.commentaire ?? ""}
                                        onChange={(event) => updateDraft(objectif.id, { commentaire: event.target.value })}
                                    />
                                </Field>
                                <button className="perf-btn perf-btn--primary perf-btn--compact" type="button" disabled={!expired} onClick={() => save(objectif)}>
                                    {managerEvaluation ? "Réévaluer" : "Evaluer"}
                                </button>
                            </div>
                        </article>
                    );
                })}
            </div>
        </StepState>
    );
}
